module.exports = __webpack_public_path__ + "img/complife-group-logo.965b8892.jpg";